<template>
  <div
    :class="model_true!=='four'?'containerbj':'containerbjFour'"
    :style=" {backgroundImage:'url('+topcontainerbackground+')'}"
  >
    <div :class="model_true!=='four'?'background_color':'background_colorFour'">
      <div id="bottom_scroll" class="header">
        <div class="page">
          <div class="topcontent">
            <!-- <i style=" margin-top: 4px;margin-left: 15px;" class=" iconfont icon-caidan" @click="set_click_nav" type="primary"></i> -->
            <div class="ifshowblockone" v-if="isloginfalseortrue">
              <div
                v-if="msg==1"
                v-show="listaddmodule"
                @click="isxiugaishowaddmodule"
                style="color:#ffffff;  cursor: pointer;"
                :style="{'background':all_app_color}"
                class="iconfont icon-xiugai bianjitoppaixuanniu showManagementbutton"
              >
                <span style="marginLeft:5px;    margin-left: auto;">{{$t('lang.new_module')}}</span>
              </div>
              <div
                v-if="isloginADorGU=='AD'||isloginADorGU=='SAD'"
                v-show="listpaixu"
                @click="isxiugaishowlistpaixu"
                style="color:#ffffff;  cursor: pointer;"
                :style="{'background':all_app_color}"
                class="iconfont icon-xiugai bianjitoppaixuanniu showManagementbutton"
              >
                <span style="marginLeft:5px;    margin-left: auto;">{{$t('lang.Module_sorting')}}</span>
              </div>

              <div
                v-if="isloginADorGU=='AD'||isloginADorGU=='SAD'"
                @click="isxiugaishow"
                v-show="isxiugaishowbianji"
                style="color:#ffffff;  cursor: pointer;"
                :style="{'background-color':all_app_color}"
                class="iconfont icon-xiugai bianjitopanniu showManagementbutton"
              >
                <span style="marginLeft:5px;    margin-left: auto;">{{$t('lang.editor')}}</span>
              </div>
              <div
                v-if="isloginADorGU=='AD'||isloginADorGU=='SAD'"
                style="width:90px;  cursor: pointer;"
                @click="overshowactionhidden"
                v-show="isshowxiugaiwancheng"
                :style="{'background-color':all_app_color}"
                class="iconfont icon-xiugai bianjitopanniu showManagementbutton"
              >
                <span style="marginLeft:5px;  margin-left: auto;">{{$t('lang.Exit_the_editor')}}</span>
              </div>
              <!-- <div class="topleftlie showManagementbutton">
                <a
                  href="http://yuhoutech.com/ktz/index.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >{{$t('lang.Thecloudteam')}}</a>
              </div>-->
              <div
                class="topleftlie showManagementbutton"
                v-if="isloginADorGU=='AD'||isloginADorGU=='SAD'"
                @click="goWebAdministration"
              >{{$t('lang.website_management')}}</div>

              <el-dropdown>
                <div
                  @mouseenter="namegrzxshow=true"
                  @mouseleave="namegrzxshow=false"
                  class="toprightlie"
                >
                  <span style="color:#ffffff;cursor: pointer;font-size:16px;">{{login_name}}</span>
                  <span
                    style="font-size: 15px; cursor: pointer;color:#ffffff;"
                    class="iconfont icon-zuo"
                    :class="namegrzxshow?'transfromxuanzhuan':''"
                  ></span>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <!-- <ul style=" cursor: pointer;"> -->
                  <el-dropdown-item>
                    <li
                      v-if="isloginADorGU!='SAD'"
                      @click.stop="goPeopleCore"
                      class="min_is_hidden"
                    >{{$t('lang.Personal_center')}}</li>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <li
                      v-if="isloginADorGU!='SAD'"
                      @click.stop="goPeopleIndex"
                    >{{$t('lang.personal_homepage')}}</li>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <li
                      v-if="isloginADorGU!='SAD'"
                      @click.stop="goPeopleProgress"
                      class="min_is_hidden"
                    >{{$t('lang.research_achievements')}}</li>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <li @click.stop="clickexitlogin">{{$t('lang.Log_out')}}</li>
                  </el-dropdown-item>
                  <!-- </ul> -->
                </el-dropdown-menu>
              </el-dropdown>

              <div v-if="isjiantingrouter&&''"></div>
            </div>

            <div v-else class="ifshowblockone ifshowblocktwo">
              <div class="topleftlie">
                <span @click="loginclick">{{$t('lang.login')}}</span>&nbsp|&nbsp
                <span @click="registerclick">{{$t('lang.register')}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="topleftlie" style="width: 36px;" @click="loginclick">登录</div> -->
      <div class="page" id="scroll_zero">
        <div class="topcontent">
          <div class="ifshowblockone" v-if="isloginfalseortrue">
            <div
              v-if="msg==1"
              v-show="listaddmodule"
              @click="isxiugaishowaddmodule"
              style="color:#ffffff; cursor: pointer;"
              :style="{'background':all_app_color}"
              class="iconfont icon-xiugai bianjitoppaixuanniu showManagementbutton"
            >
              <span style="marginLeft:5px;    margin-left: auto;">{{$t('lang.new_module')}}</span>
            </div>
            <div
              v-if="isloginADorGU=='AD'||isloginADorGU=='SAD'"
              v-show="listpaixu"
              @click="isxiugaishowlistpaixu"
              style="color:#ffffff; cursor: pointer;"
              :style="{'background':all_app_color}"
              class="iconfont icon-xiugai bianjitoppaixuanniu showManagementbutton"
            >
              <span style="marginLeft:5px;    margin-left: auto;">{{$t('lang.Module_sorting')}}</span>
            </div>
            <div
              v-if="isloginADorGU=='AD'||isloginADorGU=='SAD'"
              @click="isxiugaishow"
              v-show="isxiugaishowbianji"
              style="color:#ffffff; cursor: pointer;"
              :style="{'background-color':all_app_color}"
              class="iconfont icon-xiugai bianjitopanniu showManagementbutton"
            >
              <span style="marginLeft:5px;    margin-left: auto;">{{$t('lang.editor')}}</span>
            </div>
            <div
              v-if="isloginADorGU=='AD'||isloginADorGU=='SAD'"
              style="width:90px;color:#fff; cursor: pointer;"
              @click="overshowactionhidden"
              v-show="isshowxiugaiwancheng"
              :style="{'background-color':all_app_color}"
              class="iconfont icon-xiugai bianjitopanniu showManagementbutton"
            >
              <span style="marginLeft:5px;  margin-left: auto;">{{$t('lang.Exit_the_editor')}}</span>
            </div>
            <div
              style="width:60px; cursor: pointer;"
              v-if="EnglishUrl_label"
              @click="switch_the_language"
              :style="{'background-color':all_app_color}"
              class="bianjitopanniu"
            >
              <span style="marginLeft:5px;  margin-left: auto;">{{$t('lang.language')}}</span>
            </div>

            <!-- <div class="topleftlie showManagementbutton">
              <a
                href="http://yuhoutech.com/ktz/index.html"
                target="_blank"
                rel="noopener noreferrer"
              >{{$t('lang.Thecloudteam')}}</a>
            </div>-->
            <div
              class="topleftlie showManagementbutton"
              v-if="isloginADorGU=='AD'||isloginADorGU=='SAD'"
              @click="goWebAdministration"
            >{{$t('lang.website_management')}}</div>
            <el-dropdown>
              <div
                @mouseenter="namegrzxshow=true"
                @mouseleave="namegrzxshow=false"
                class="toprightlie"
              >
                <span style="color:#ffffff;cursor: pointer;font-size:16px;">{{login_name}}</span>
                <span
                  style="font-size: 15px; cursor: pointer;color:#ffffff;"
                  class="iconfont icon-zuo"
                  :class="namegrzxshow?'transfromxuanzhuan':''"
                ></span>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <li
                    v-if="isloginADorGU!='SAD'"
                    @click.stop="goPeopleCore"
                    class="min_is_hidden"
                  >{{$t('lang.Personal_center')}}</li>
                </el-dropdown-item>
                <el-dropdown-item>
                  <li v-if="isloginADorGU!='SAD'" @click.stop="goPeopleIndex">
                    {{$t('lang.personal_homepage')}}
                    <!-- <a ref="target" href target="_blank" class="target"></a> -->
                  </li>
                </el-dropdown-item>
                <el-dropdown-item>
                  <li
                    v-if="isloginADorGU!='SAD'"
                    @click.stop="goPeopleProgress"
                    class="min_is_hidden"
                  >{{$t('lang.research_achievements')}}</li>
                </el-dropdown-item>
                <el-dropdown-item>
                  <li @click.stop="clickexitlogin">{{$t('lang.Log_out')}}</li>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <!-- <div class="hovershowlist">
                <ul style=" cursor: pointer;">
                </ul>
            </div>-->

            <div v-if="isjiantingrouter&&''"></div>
            <!-- <a href="" ref="target" target="_blank" rel="noopener noreferrer"></a> -->
          </div>

          <div v-else class="ifshowblockone ifshowblocktwo">
            <div
              style="width:60px; cursor: pointer;"
              v-if="EnglishUrl_label"
              @click="switch_the_language"
              class="bianjitopanniu"
              :style="{'background-color':all_app_color}"
            >
              <span style="marginLeft:5px;  margin-left: auto;">{{$t('lang.language')}}</span>
            </div>
            <div class="topleftlie">
              <span @click="loginclick">{{$t('lang.login')}}</span>&nbsp|&nbsp
              <span @click="registerclick">{{$t('lang.register')}}</span>
            </div>
          </div>
        </div>
        <div class="bottomcontent">
          <div
            class="bottomcontent_img_div"
            :style="{'width':model_true=='three'?'auto':''}"
            v-if="model_true=='one'||model_true=='three'"
          >
            <img
              :style="{'width':model_true=='three'?'auto':''}"
              class="titleimg"
              :src="topcontainer.logo"
              alt
            />
          </div>
          <div class="centertitle">
            <div
              v-if="model_true=='one'||model_true=='two'"
              class="centertitletop"
            >{{topcontainer.title}}</div>
            <div
              v-if="model_true=='one'||model_true=='two'"
              class="centertitlebottom"
            >{{topcontainer.subtitle}}</div>
          </div>
          <div v-show="false">{{all_app_color_comp}}</div>
          <div
            style=" cursor: pointer;"
            class="iconfont icon-xiugai isxiugai"
            @click="to_HT_header"
            v-if="isloginADorGU=='AD'||isloginADorGU=='SAD'"
            v-show="isshowxiugai"
          ></div>
        </div>
      </div>
    </div>
    <!-- 新手引导 -->
    <!-- <el-drawer
      style="color:#333333;font-size:20px;overflow-y:scroll;"
      :title="$t('languageAllocation.newGuide.clickNewGuide')"
      size="400px"
      :visible.sync="newGuideDrawer"
    >
      <div style="font-size:16px;padding: 10px 20px;">
        <el-radio-group v-model="tabPosition" style="margin-bottom: 30px;">
          <el-radio-button
            label="baseConfiger"
          >{{$t("languageAllocation.newGuide.baseConfigerBtn")}}</el-radio-button>
          <el-radio-button
            label="siteConfiger"
          >{{$t("languageAllocation.newGuide.siteConfigerBtn")}}</el-radio-button>
          <el-radio-button
            label="contentConfiger"
          >{{$t("languageAllocation.newGuide.contentConfigerBtn")}}</el-radio-button>
        </el-radio-group>
        <div v-if="tabPosition == 'baseConfiger'">
          <el-steps direction="vertical" space="85px" :active="activeIndexOne">
            <el-step>
              <template slot="title">
                <router-link
                  :style="{'color':activeIndexOne==1?ht_all_app_color:''}"
                  @click.native="guide_one_step(1)"
                  to="/dynamic"
                >{{$t("languageAllocation.newGuide.dynamicTitle")}}</router-link>
              </template>
              <template slot="description">
                <div
                  :style="{'color':activeIndexOne==1?ht_all_app_color:''}"
                >{{$t("languageAllocation.newGuide.dynamicDesc")}}</div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <router-link
                  :style="{'color':activeIndexOne==2?ht_all_app_color:''}"
                  @click.native="guide_one_step(2)"
                  to="/member"
                >{{$t("languageAllocation.newGuide.memberTitle")}}</router-link>
              </template>
              <template slot="description">
                <div
                  :style="{'color':activeIndexOne==2?ht_all_app_color:''}"
                >{{$t("languageAllocation.newGuide.memberDesc")}}</div>
              </template>
            </el-step>
          </el-steps>
        </div>
        <div v-if="tabPosition == 'siteConfiger'">
          <el-steps direction="vertical" space="85px" :active="activeIndexTwo">
            <el-step>
              <template slot="title">
                <router-link
                  :style="{'color':activeIndexTwo==1?ht_all_app_color:''}"
                  @click.native="guide_two_step(1)"
                  to="/indexConfig"
                >{{$t("languageAllocation.newGuide.indexConfigTitle")}}</router-link>
              </template>
              <template slot="description">
                <div
                  :style="{'color':activeIndexTwo==1?ht_all_app_color:''}"
                >{{$t("languageAllocation.newGuide.indexConfigDesc")}}</div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <router-link
                  :style="{'color':activeIndexTwo==2?ht_all_app_color:''}"
                  @click.native="guide_two_step(2)"
                  to="/menuConfig"
                >{{$t("languageAllocation.newGuide.menuConfigTitle")}}</router-link>
              </template>
              <template slot="description">
                <div
                  :style="{'color':activeIndexTwo==2?ht_all_app_color:''}"
                >{{$t("languageAllocation.newGuide.menuConfigDesc")}}</div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <router-link
                  :style="{'color':activeIndexTwo==3?ht_all_app_color:''}"
                  @click.native="guide_two_step(3)"
                  to="/headConfig"
                >{{$t("languageAllocation.newGuide.headConfigTitle")}}</router-link>
              </template>
              <template slot="description">
                <div
                  :style="{'color':activeIndexTwo==3?ht_all_app_color:''}"
                >{{$t("languageAllocation.newGuide.headConfigDesc")}}</div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <router-link
                  :style="{'color':activeIndexTwo==4?ht_all_app_color:''}"
                  @click.native="guide_two_step(4)"
                  to="/footerConfig"
                >{{$t("languageAllocation.newGuide.footerConfigTitle")}}</router-link>
              </template>
              <template slot="description">
                <div
                  :style="{'color':activeIndexTwo==4?ht_all_app_color:''}"
                >{{$t("languageAllocation.newGuide.footerConfigDesc")}}</div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <router-link
                  :style="{'color':activeIndexTwo==5?ht_all_app_color:''}"
                  @click.native="guide_two_step(5)"
                  to="/colorConfig"
                >{{$t("languageAllocation.newGuide.colorConfigTitle")}}</router-link>
              </template>
              <template slot="description">
                <div
                  :style="{'color':activeIndexTwo==5?ht_all_app_color:''}"
                >{{$t("languageAllocation.newGuide.colorConfigDesc")}}</div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <router-link
                  :style="{'color':activeIndexTwo==6?ht_all_app_color:''}"
                  @click.native="guide_two_step(6)"
                  to="/typeConfig"
                >{{$t("languageAllocation.newGuide.typeConfigTitle")}}</router-link>
              </template>
              <template slot="description">
                <div
                  :style="{'color':activeIndexTwo==6?ht_all_app_color:''}"
                >{{$t("languageAllocation.newGuide.typeConfigDesc")}}</div>
              </template>
            </el-step>
          </el-steps>
        </div>
        <div v-if="tabPosition == 'contentConfiger'">
          <el-steps direction="vertical" space="85px" :active="activeIndexThree">
            <el-step>
              <template slot="title">
                <router-link
                  :style="{'color':activeIndexThree==1?ht_all_app_color:''}"
                  @click.native="guide_three_step(1)"
                  to="/researchIntroduce"
                >{{$t("languageAllocation.newGuide.researchIntroduceTitle")}}</router-link>
              </template>
              <template slot="description">
                <div
                  :style="{'color':activeIndexThree==1?ht_all_app_color:''}"
                >{{$t("languageAllocation.newGuide.researchIntroduceDesc")}}</div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <router-link
                  :style="{'color':activeIndexThree==2?ht_all_app_color:''}"
                  @click.native="guide_three_step(2)"
                  to="/researchDirection"
                >{{$t("languageAllocation.newGuide.researchDirectionTitle")}}</router-link>
              </template>
              <template slot="description">
                <div
                  :style="{'color':activeIndexThree==2?ht_all_app_color:''}"
                >{{$t("languageAllocation.newGuide.researchDirectionDesc")}}</div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <router-link
                  :style="{'color':activeIndexThree==3?ht_all_app_color:''}"
                  @click.native="guide_three_step(3)"
                  to="/researchProgress"
                >{{$t("languageAllocation.newGuide.researchProgressTitle")}}</router-link>
              </template>
              <template slot="description">
                <div
                  :style="{'color':activeIndexThree==3?ht_all_app_color:''}"
                >{{$t("languageAllocation.newGuide.researchProgressDesc")}}</div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <router-link
                  :style="{'color':activeIndexThree==4?ht_all_app_color:''}"
                  @click.native="guide_three_step(4)"
                  to="/researchProject"
                >{{$t("languageAllocation.newGuide.researchProjectTitle")}}</router-link>
              </template>
              <template slot="description">
                <div
                  :style="{'color':activeIndexThree==4?ht_all_app_color:''}"
                >{{$t("languageAllocation.newGuide.researchProjectDesc")}}</div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <router-link
                  :style="{'color':activeIndexThree==5?ht_all_app_color:''}"
                  @click.native="guide_three_step(5)"
                  to="/teamIntroduce"
                >{{$t("languageAllocation.newGuide.teamIntroduceTitle")}}</router-link>
              </template>
              <template slot="description">
                <div
                  :style="{'color':activeIndexThree==5?ht_all_app_color:''}"
                >{{$t("languageAllocation.newGuide.teamIntroduceDesc")}}</div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <router-link
                  :style="{'color':activeIndexThree==6?ht_all_app_color:''}"
                  @click.native="guide_three_step(6)"
                  to="/researchEquipment"
                >{{$t("languageAllocation.newGuide.researchEquipmentTitle")}}</router-link>
              </template>
              <template slot="description">
                <div
                  :style="{'color':activeIndexThree==6?ht_all_app_color:''}"
                >{{$t("languageAllocation.newGuide.researchEquipmentDesc")}}</div>
              </template>
            </el-step>
          </el-steps>
        </div>
      </div>
    </el-drawer>-->
  </div>
</template>

<script>
import vmson from "../emptyVue";
import * as serviceApi from "./api/header";
export default {
  name: "headerr",
  props: ["msg"],
  data() {
    return {
      newGuideDrawer: false,
      model_true: "one",
      all_app_color: "#3b9dce",
      namegrzxshow: false, //是否移入了姓名的范围，判断是否显示个人中心按钮
      listpaixu: false, //点击了编辑按钮时是否显示排序按钮
      listaddmodule: false, //点击了编辑按钮时是否显示排序按钮
      isxiugaishowbianji: true, //当前路由没有跳转到负责人介绍的页面时  解开所有编辑按钮的封印    点击编辑按钮也不隐藏编辑按钮
      // isrouterwancheng: false,          //当前路由跳转到了负责人介绍的页面时 解开完成按钮一层封印
      isshowxiugaiwancheng: false, //点击完成时的修改按钮的显示隐藏的状态
      jiantingrouter: false, //为了监听当前路由是否跳转到了负责人介绍的页面

      topcontainer: "",
      topcontainerbackground: "",
      is_grzx_toblank: true,
      EnglishUrl_label: ""
    };
  },
  mounted() {
    //监听滚动条
    let bottom_scroll_id = document.querySelector("#bottom_scroll");
    let scroll_zero_id = document.querySelector("#scroll_zero");
    let that = this;
    window.onscroll = function(e) {
      if (scrollY < 120) {
        bottom_scroll_id.style.display = "none";
        scroll_zero_id.style.display = "block";
      } else {
        bottom_scroll_id.style.display = "block";
      }
    };
    // this.fuzhuisshowxiugai=!this.$store.state.isshowxiugai;
  },
  computed: {
    all_app_color_comp() {
      if (this.$store.state.all_app_color) {
        this.all_app_color = this.$store.state.all_app_color; //将本地的全局配色，赋值给 this.all_app_color
      }
      return "";
    },

    //监听是否点击了编辑的按钮
    isshowxiugai() {
      return this.$store.state.isshowxiugai;
    },
    //监听判断是否已经登录
    isloginfalseortrue() {
      return this.$store.state.role_name;
    },
    //监听判断是否已经管理员登录
    isloginADorGU() {
      return this.$store.state.role;
    },
    //为了监听当前路由是否跳转到了负责人介绍的页面   必须写在页面上才能执行
    isjiantingrouter() {
      this.jiantingrouter = false;
      if (this.$router.currentRoute.path == "/principalIntroduce") {
        // this.isrouterwancheng = true;
      } else {
        this.listpaixu = false;
        this.listaddmodule = false;
        this.isxiugaishowbianji = true;
        // this.isrouterwancheng = false;
      }

      // console.log(this.$store.state.isavtivenav);   //为true就表示点击了导航栏切换
      // if (this.$store.state.isavtivenav) {
      //   this.isshowxiangqing = false;
      //   this.requestshebeidatalist();
      // }
      // this.$store.commit("changeisshowxiangqing");
      if (this.isobject(this.$store.state.navdata)) {
        this.$store.commit("isfalseclickshow");
        // this.$store.commit("isclickshow");
        // this.isxiugaishowbianji = true;
        this.isshowxiugaiwancheng = false;
        // this.dynamic_router_path = this.$store.state.navdata.portal_routes;
        // return this.$store.state.navdata;
      }
      //  else {
      //   return false;
      // }

      return false;
    }
  },
  methods: {
    // set_click_nav() {
    //   // drawer = true
    //   this.$store.commit("change_ture_false_click_nav", true);
    // },
    get_select_config() {
      serviceApi
        .get_select_config({
          type: "head_model"
        })
        .then(body => {
          if (body.success) {
            if (body.data.label == "YTMB00001") {
              this.model_true = "one";
            } else if (body.data.label == "YTMB00002") {
              this.model_true = "two";
            } else if (body.data.label == "YTMB00003") {
              this.model_true = "three";
            } else {
              this.model_true = "four";
            }

            this.$store.commit("change_header_model_true", true);
            this.$store.commit(
              "change_header_model_true_value",
              this.model_true
            );
          }
        });
    },
    //点击切换语言
    switch_the_language() {
      if (this.EnglishUrl_label) {
        window.open(this.EnglishUrl_label, "_blank");
      }
      // let lang = this.$i18n.locale === "zh-CN" ? "en-US" : "zh-CN";
      // this.$i18n.locale = lang;
      // this.$store.commit("change_i18n_locale", lang);
      // localStorage.setItem("locale", lang);
    },
    //判断对象是否为空
    isobject(aaa) {
      for (let i in aaa) {
        return true; //非空
      }
      return false;
    },
    //跳转到后台
    to_HT_header() {
      // window.open(this.GLOBAL.HT_headConfig);
      serviceApi.checkUserIsLogin().then(res => {
        if (res.success) {
          window.open(this.GLOBAL.HT_headConfig);
        } else {
          this.$message({
            showClose: true,
            message: "登录已过期，或已退出请重新登录！",
            type: "error"
          });
          this.isloginfalseortrue = true;
          //删除浏览器中的用户信息
          this.$store.commit("clickexitloginshandata");
          window.sessionStorage.removeItem("head");
          window.sessionStorage.removeItem("role");
          window.sessionStorage.removeItem("role_name");
        }
      });
    },
    //请求页面主要内容数据列表
    getDataList() {
      let that = this;
      serviceApi.getDataList().then(body => {
        that.topcontainer = body.data;
        that.topcontainerbackground = body.data.picture[0];
        that.$store.commit("changetopcontainer", that.topcontainer);
      });
    },
    //推出登录
    logout() {
      let that = this;
      serviceApi.logout().then(body => {
        if (body.success) {
          let str = "";
          body.msg.forEach(element => {
            str = str + element + "<br/>";
          });
          that.$message({
            type: "success",
            dangerouslyUseHTMLString: true,
            message: str
          });
        } else {
          let str = "";
          body.msg.forEach(element => {
            str = str + element + "<br/>";
          });
          that.$message({
            type: "error",
            dangerouslyUseHTMLString: true,
            message: str
          });
        }
      });
    },
    //网站管理
    goWebAdministration() {
      // window.open(this.GLOBAL.HT_INDEX_);
      serviceApi.checkUserIsLogin().then(res => {
        if (res.success) {
          window.open(this.GLOBAL.HT_INDEX_);
        } else {
          this.$message({
            showClose: true,
            message: "登录已过期，或已退出请重新登录！",
            type: "error"
          });
          this.isloginfalseortrue = true;
          //删除浏览器中的用户信息
          this.$store.commit("clickexitloginshandata");
          window.sessionStorage.removeItem("head");
          window.sessionStorage.removeItem("role");
          window.sessionStorage.removeItem("role_name");
        }
      });
    },
    //个人中心
    goPeopleCore() {
      // window.open(this.GLOBAL.ZX_INDEX_);
      serviceApi.checkUserIsLogin().then(res => {
        if (res.success) {
          window.open(this.GLOBAL.ZX_INDEX_);
        } else {
          this.$message({
            showClose: true,
            message: "登录已过期，或已退出请重新登录！",
            type: "error"
          });
          this.isloginfalseortrue = true;
          //删除浏览器中的用户信息
          this.$store.commit("clickexitloginshandata");
          window.sessionStorage.removeItem("head");
          window.sessionStorage.removeItem("role");
          window.sessionStorage.removeItem("role_name");
        }
      });
    },
    //个人成果
    goPeopleProgress() {
      // window.open(this.GLOBAL.ZX_PROGRESS_);
      serviceApi.checkUserIsLogin().then(res => {
        if (res.success) {
          window.open(this.GLOBAL.ZX_PROGRESS_);
        } else {
          this.$message({
            showClose: true,
            message: "登录已过期，或已退出请重新登录！",
            type: "error"
          });
          this.isloginfalseortrue = true;
          //删除浏览器中的用户信息
          this.$store.commit("clickexitloginshandata");
          window.sessionStorage.removeItem("head");
          window.sessionStorage.removeItem("role");
          window.sessionStorage.removeItem("role_name");
        }
      });
    },
    // go_to_window_open(url){
    //   window.open(url,'_blank');
    // },
    //个人主页
    goPeopleIndex() {
      let winHandler = window.open("", "_blank");
      // alert('个人主页,的点击');
      //获取用户id
      let that = this;
      if (this.is_grzx_toblank) {
        this.is_grzx_toblank = false;
        serviceApi.checkUserIsLogin().then(res => {
          if (res.success) {
            //获取用户id
            serviceApi.getUserID().then(res => {
              if (res.success) {
                let json_data = "";
                let path = this.$router.currentRoute.path;

                let arr_string = path.split("/");
                if (arr_string.length > 2) {
                  json_data =
                    res.data.user_id +
                    "." +
                    arr_string[1] +
                    "." +
                    arr_string[2] +
                    "." +
                    arr_string[3];
                } else {
                  json_data = res.data.user_id + "." + arr_string[1];
                }
                // let path_new=path.substr(0,path.length-1);
                // this.$store.commit('change_home_more_click',true);
                // let str = "member/" + json_data;
                let str = "";
                if (res.data.link_suffix) {
                  str = "member/" + res.data.link_suffix;
                } else {
                  let json_data = res.data.user_id + "." + "home";
                  str = "member/" + json_data;
                }
                // let str = "member/" + res.data.user_id;
                let routeData = this.$router.resolve({
                  name: str
                });
                // that.go_to_window_open(routeData.href + str);
                // var newWindow = window.open();
                // $.ajax({
                //   url: "a/aa",
                //   success: function(str) {
                //     //修改新窗口的url
                //     newWindow.location.href = routeData.href + str;
                //   }
                // });
                // window.open(routeData.href + str, "_blank");
                // alert(routeData.href + str);
                winHandler.location.href = routeData.href + str;
                // window.open(routeData.href + str, "_blank");
                //  alert('routeData.href + str');
                // let target = this.$refs.target;
                //  alert(window.location.origin +window.location.pathname+ routeData.href + str);
                // target.setAttribute(
                //   "href",
                //   window.location.origin +window.location.pathname+ routeData.href + str
                // );
                // target.click();
                //  alert('window.location.origin +window.location.pathname+ routeData.href + str');
              }
            });
          } else {
            this.$message({
              showClose: true,
              message: "登录已过期，或已退出请重新登录！",
              type: "error"
            });
            this.isloginfalseortrue = true;
            //删除浏览器中的用户信息
            this.$store.commit("clickexitloginshandata");
            window.sessionStorage.removeItem("head");
            window.sessionStorage.removeItem("role");
            window.sessionStorage.removeItem("role_name");
          }
        });
        setTimeout(() => {
          that.is_grzx_toblank = true;
        }, 2000);
      }
    },
    //点击退出登录按钮
    clickexitlogin() {
      this.logout();
      this.$store.commit("clickexitloginshandata");
      window.sessionStorage.removeItem("head");
      window.sessionStorage.removeItem("role");
      window.sessionStorage.removeItem("role_name");
      window.sessionStorage.removeItem("login_switch");
      this.isxiugaishowbianji = false;
    },
    //点击登录按钮
    loginclick() {
      // window.scrollTo(0, 0);  // 置顶代码
      this.$router.push("/login");
    },
    //点击注册按钮
    registerclick() {
      // window.scrollTo(0, 0);  // 置顶代码
      this.$router.push("/register");
    },
    // //点击
    // gohomeclick() {
    //   // window.scrollTo(0, 0);  // 置顶代码
    //   this.$router.push("/home");
    // },
    // gNewbieTask() {
    //   this.newGuideDrawer = true;
    //   // window.scrollTo(0, 0);  // 置顶代码
    //   // this.$router.push("/home");
    // },
    //点击了排序的按钮
    isxiugaishowlistpaixu() {
      // this.isxiugaishowbianji = false;
      // if (this.$router.currentRoute.path == "/principalIntroduce") {
      //   this.listpaixu = true;
      // }
      vmson.$emit("showislistpaixu", this.msg);
    },
    isxiugaishowaddmodule() {
      vmson.$emit("showislistaddmodule", this.msg);
    },
    //点击编辑按钮执行的事件
    isxiugaishow() {
      this.$store.commit("isclickshow");
      this.isxiugaishowbianji = false;
      this.isshowxiugaiwancheng = true;
      if (this.$router.currentRoute.path == "/principalIntroduce") {
        this.listpaixu = true;
        this.listaddmodule = true;

        // this.isrouterwancheng=true;
      }

      // this.isshowxiugai=true;
    },
    //是否点击了姓名区域，也是用来判断是否显示个人中心按钮
    namegrzxshowclick() {
      this.namegrzxshow = !this.namegrzxshow;
    },
    //点击完成时 隐藏以下全部的编辑按钮 并提交
    overshowactionhidden() {
      // this.isshowxiugai=false;
      this.$store.commit("isclickshow");
      this.isxiugaishowbianji = true;
      this.isshowxiugaiwancheng = false;
      this.listpaixu = false;
      this.listaddmodule = false;

      if (this.$router.currentRoute.path == "/principalIntroduce") {
        // this.listpaixu = true;
        vmson.$emit("click_header_end_bianji", this.msg);
        // this.isrouterwancheng=true;
      }
    }
  },
  created() {
    if (this.$store.state.EnglishUrl) {
      this.EnglishUrl_label = this.$store.state.EnglishUrl;
    }
    if (!this.$store.state.header_model_true) {
      this.get_select_config();
    } else {
      this.model_true = this.$store.state.header_model_true_value;
    }

    if (this.$store.state.all_app_color) {
      this.all_app_color = this.$store.state.all_app_color;
    } else {
      this.all_app_color = localStorage.getItem("all_app_color"); //将本地的全局配色，赋值给 this.all_app_color
    }

    if (localStorage.getItem("locale")) {
      this.$store.commit("change_i18n_locale", localStorage.getItem("locale"));
      this.$i18n.locale = localStorage.getItem("locale");
    } else {
      let lang = this.$i18n.locale;
      this.$store.commit("change_i18n_locale", lang);
      localStorage.setItem("locale", lang);
    }
    let login_name = sessionStorage.getItem("role_name");
    if (login_name != null || login_name != "") {
      this.login_name = login_name;
      this.isxiugaishowbianji = true;
    }

    if (this.$store.state.topcontainer == "") {
      this.getDataList();
    } else {
      this.topcontainer = this.$store.state.topcontainer;
      this.topcontainerbackground = this.topcontainer.picture[0];
    }

    if (sessionStorage.getItem("editStatus")) {
      this.isxiugaishow();
      window.sessionStorage.removeItem("editStatus");
    }
  },
  watch: {
    "$store.state.EnglishUrl": function(curVal, oldVal) {
      // console.log(curVal, oldVal);
      if (curVal) {
        this.EnglishUrl_label = curVal;
        //   this.$router.push({ path: "/Manyrichtextxiangqing", query: { id: id } });
        // this.$store.commit("TWLBXQ", "");
      }
    }
    // $route(to, from) {
    //   if (to.path == "/principalIntroduce") {
    //     this.isrouterwancheng = true;
    //   } else {
    //     this.listpaixu = false;
    //     this.isxiugaishowbianji = true;
    //     this.isrouterwancheng = false;
    //   }
    // }
  }
};
</script>
<style>
.header .el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  color: var(--color);
}
</style>
<style scoped>
.bottomcontent_img_div {
  width: 92px;
  height: 100px;
}
.background_color {
  background-color: rgba(0, 0, 0, 0.4);
  height: 100%;
  width: 100%;
  min-height: 180px;
}
#scroll_zero {
  padding-top: 5px;
}
#bottom_scroll {
  position: fixed;
  top: 0;
  z-index: 999;
  background-color: #333333;
  width: 100%;
  padding: 0px 0;
  display: none;
}

.bianjitoppaixuanniu {
  margin-top: 7px;
  margin-right: 26px;
  margin-left: auto;
  font-size: 12px;
  background: #a2afb5;
  border-radius: 9px;
  height: 24px;
  line-height: 24px;
  /* width: 78px; */
  padding: 0 10px;
  text-align: center;
}
.transfromxuanzhuan {
  display: inline-block;
  transition: 0.5s;
  transform: rotate(90deg);
}

.bianjitopanniu {
  margin-top: 7px;
  margin-right: 26px;
  margin-left: auto;
  font-size: 12px;
  background: #1699d5;
  border-radius: 9px;
  height: 24px;
  line-height: 24px;
  width: 70px;
  text-align: center;
}
.ifshowblocktwo {
  margin-left: auto;
}

.isxiugai {
  width: 30px;
  height: 30px;
  line-height: 30px;
  margin: 15px 0 0 15px;
  font-weight: 600;
  /* color: #cccccc; */
  cursor: pointer;
}

.centertitlebottom {
  font-size: 16px;
  color: #ffffff;
  word-break: break-all;
}
.centertitletop {
  font-size: 34px;
  margin-top: 15px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 10px;
  word-break: break-all;
}
.titleimg {
  width: 92px;
  height: 94px;
  /* border-radius: 50%; */
}
.centertitle {
  margin-left: 10px;
}
.bottomcontent {
  /* width: 400px; */
  margin-left: 2%;
  /* height: 100px; */
  display: flex;
  margin-top: 20px;
  padding-bottom: 10px;
}
/* 顶部 */
.ifshowblockone {
  display: flex;
  margin-left: auto;
}
.ifshowblockone .icon-xiugai {
  color: #ffffff;
}
.page {
  width: 1200px;
  margin: 0 auto;
  /* padding-top: 10px; */
}
.containerbj {
  background: url("../../../assets/headerbj.png");
  /* background-position-x: center; */
  /* background-size: cover; */
  /* background-repeat: round; */
  /* padding: 0px; */
  border: none;
  border-radius: 0px;
  /* height: 180px; */
  /* min-width: 1200px; */

  /* position: relative; */
  overflow: hidden;
  width: 100%;
  min-height: 180px;
  color: #fff;
  padding: 0;
  background-repeat: no-repeat;
  /* background-size: 1920px 180px; */
  background-size: cover;
  background-position-y: center;
}
.containerbjFour {
  background: url("../../../assets/headerbj.png");

  border: none;
  border-radius: 0;
  overflow: hidden;
  width: 100%;
  height: 180px;
  color: #fff;
  padding: 0;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
}
/* .topcontent::after{
  position:absolute;
            left: 0;
            top:0;
            display: block;
            width:100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
            transform: translateY(-100%);
} */
.topcontent {
  color: #ffffff;
  height: 36px;
  line-height: 36px;
  display: flex;
  position: relative;
  margin-right: 20px;
}
.toprightlie {
  margin-left: auto;
  margin-right: 20px;
}

/* .toprightlie:hover .hovershowlist {
  top: 35px;
}
.toprightlie:hover .hovershowlist ul {
  top: 0;
} */
.hovershowlist {
  /* transition: 1s; */
  transition: 1s all;
  /* opacity: 0; */
  position: absolute;
  right: 12px;
  top: 35px;
  border-radius: 5px;
  color: #ffffff;
  font-size: 15px;
  overflow: hidden;
  z-index: 1000;

  /* color: #ffffff;
  font-size: 15px;
  overflow: hidden;
  position: absolute;
  right: 12px;
  top: 35px;
  border-radius: 5px;
  padding: 10px;
  z-index: 1000;
  background: #333333;
  color: #ffffff;
  font-size: 15px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 8px 3px; */
}
.hovershowlist ul {
  /* background: #666666; */
  padding: 10px;
  /* box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 8px 3px; */
  /* position: relative;
  top: -150px;
  left: 0; */
  /* transition: 1s all; */
  background-color: #333;
  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.3);
}
.hovershowlist ul li {
  height: 25px;
  line-height: 25px;
  font-size: 14px;
}
/* 登录注册 */
.topleftlie {
  /* width: 64px; */
  margin-right: 25px;
  margin-left: auto;
  cursor: pointer;
}
.toprightlietwo {
  margin-left: auto;
  margin-right: 20px;
}
@media (min-width: 992px) and (max-width: 1199px) {
  /* .containerbj {
    min-width: 992px;
  } */
  .page {
    width: 992px;
  }
  .centertitletop {
    font-size: 32px;
  }
  /* .bottomcontent {
    width: 992px;
    margin: 0 auto;
  } */
}
/*在768 和991 像素之间的屏幕里，小屏幕，主要是PAD*/
@media (min-width: 768px) and (max-width: 991px) {
  /* .containerbj {
    min-width: 768px;
  } */
  .page {
    width: 768px;
  }
  .showManagementbutton {
    display: none;
  }
  .centertitletop {
    font-size: 32px;
  }
  .containerbjFour {
    background: url("../../../assets/headerbj.png");

    border: none;
    border-radius: 0;
    overflow: hidden;
    width: 100%;
    height: 180px;
    color: #fff;
    padding: 0;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: -30px;
  }
}
/*在480 和767 像素之间的屏幕里，超小屏幕，主要是手机*/
@media (min-width: 480px) and (max-width: 767px) {
  /* .containerbj {
    min-width: 480px;
  } */
  .page {
    width: 100%;
  }
  .showManagementbutton {
    display: none;
  }
  .centertitletop {
    font-size: 25px;
  }
  .centertitlebottom {
    font-size: 14px;
  }
  .textcontent p {
    font-size: 14px;
    line-height: 24px;
  }
  .containerbjFour {
    background: url("../../../assets/headerbj.png");

    border: none;
    border-radius: 0;
    overflow: hidden;
    width: 100%;
    height: 180px;
    color: #fff;
    padding: 0;
    background-repeat: no-repeat;
    /* background-size: cover; */
    background-color: #66b1ff;
    background-color: var(--color);
    /* background-position: left; */
    background-position: -115px bottom;
  }
  /* .min_is_hidden {
    display: none;
  } */
}
/*在小于480px的屏幕里，微小屏幕，更低分辨率的手机*/
@media (max-width: 479px) {
  .containerbjFour {
    background: url("../../../assets/headerbj.png");

    border: none;
    border-radius: 0;
    overflow: hidden;
    width: 100%;
    /* min-width: 520px; */
    height: 180px;
    color: #fff;
    padding: 0;
    background-repeat: no-repeat;
    /* background-size: cover; */
    background-color: var(--color);
    /* background-position: left; */
    /* background-position: -110px bottom; */

    background-position: -70px bottom;
    /* background-position: 11%; */
    /* transform: scaleX(.5); */
    /* background-size: contain; */
    background-size: 270% 140px;
  }
  /* body .containerbj {
    max-width: 479px;
    min-width: 300px;
  } */
  .page {
    width: 100%;
  }
  .bottomcontent {
    width: 98%;
    height: inherit;
    padding-bottom: 10px;
  }
  /* .titleimg {
    width: 100%;
    height: inherit;
  } */
  .titleimg {
    width: 92px;
    height: 94px;
  }
  .centertitletop {
    font-size: 20px;
    margin-top: 30px;
  }
  .topleftlie {
    margin-right: 4px;
    font-size: 14px;
  }
  .bianjitopanniu {
    margin-right: 4px;
  }
  .bianjitoppaixuanniu {
    margin-right: 0px;
  }
  .toprightlie {
    margin-left: auto;
    margin-right: 10px;
  }
  .topcontent {
    margin-right: 0px;
  }
  .showManagementbutton {
    display: none;
  }
  .centertitlebottom {
    font-size: 13px;
  }
  .textcontent p {
    font-size: 14px;
    line-height: 24px;
  }
  .titletop {
    width: 90%;
    margin-left: 5%;
  }
  /* .min_is_hidden {
    display: none;
  } */
}
</style>



// WEBPACK FOOTER //
// src/components/page/header/header.vue